import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'pbc-market-trends',
  templateUrl: './market-trends.component.html'
})
export class MarketTrendsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
